import { render, staticRenderFns } from "./AirJordanXxxvi.vue?vue&type=template&id=33d1b014&"
import script from "./AirJordanXxxvi.vue?vue&type=script&lang=js&"
export * from "./AirJordanXxxvi.vue?vue&type=script&lang=js&"
import style0 from "./AirJordanXxxvi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports